import { useState, useEffect } from "react";
import "./styles/PanelPortafolio.css";
import Search from "../generales/Search";
import Action from "../Action";
import Modal from "react-modal";
import LoadSimple from "../LoadSimple";
import ModalCreateTech from "./ModalCreateTech";
import TablePortafolioServices from "./TablePortafolioServices";
import InfoPortafolio from "./InfoPortafolio";
import Paginador from "../generales/Paginador";
import { lang } from "../generales/traduction";
import { capitalizeFirstLetter } from "../../utils/utils";
import TablePortafolioTech from "./TablePortafolioTech";
const CreateCisModalStyles = {  
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "25%",
    height: "60%",
    padding: "20px",
  },
};
const PanelPortafolioTecs = ({ server,
  ServiceSelected,
  setServiceSelected,
  tecSelected,
  setTecSelected,
  languaje,
  sla,
  setSla,
  slaService,
  setSlaService,
  handleShowPopup,
  mode
  }) => {
  const [devices, setDevices] = useState({
    data: [],
    loading: true,
    error: null,
  });




  const [listSelected, setListSelected] = useState(1);
  const [dataUsers, setDataUsers] = useState({
    data: [],
    loading: true,
    error: null,
  });
  const [dataObject, setDataObject] = useState({
    data: [],
    loading: true,
    error: null,
  })
  const [searchResults, setSearchResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  var dataList = searchTerm === "" ? (dataUsers.data.length!=0?dataUsers.data.techs:[]) : searchResults;

  const [searchResult, setSearchResult] = useState(null);
  const [limitList, setLimitList] = useState(50);
  const [pageActual, setPageActual] = useState(1);
  const startLimit = limitList * pageActual - limitList;
  const [CreateServiceModalOpen, setCreateServiceModalOpen] = useState(false);
  const pages = parseInt(dataList.length / limitList) + 1;

  const handleSelectChange = (e) => {
    setLimitList(e.target.value);setPageActual(1);
  };

  const [registerIsValid, setRegisterIsValid] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [dataCis, setDataCis] = useState([]);
  const [loadingCis, setLoadingCis] = useState(false);
  const [errorCis, setErrorCis] = useState(null);

  const [editActive, setEditActive] = useState(false);
  const [dataService, setDataService] = useState([]);

  const [loadCatalogo,setLoadCatalogo]=useState(false)
  const [loadPlantilla,setLoadPlantilla]=useState(false)


  const hadleChangeList = (e) => {
    setListSelected(e);
  };
  const handleSearch = (query) => {
    // Aquí puedes realizar la búsqueda usando el valor de 'query'
    // Por ejemplo, puedes actualizar el estado 'searchResult' con los resultados
    setSearchResult(`Resultados para: ${query}`);
  };

  const crear = () => {
    setCreateServiceModalOpen(true);
  };

  useEffect(() => {
    setPageActual(1);

   
  }, [dataList]);



  useEffect(() => {
    
    setSlaService(ServiceSelected.sla)
  }, []);

  const regresar_cis = () => {
    setServiceSelected([]);
    // setLoadingCis(true)
  };


  function closCreateServiceModal() {
    setEditActive(false);
    setCreateServiceModalOpen(false);
  }
  const handleChangEdit = (element) => {
 
    setEditActive(true);
    setDataService(element);
          setCreateServiceModalOpen(true);
  };
  const token_item=localStorage.getItem('access_token')



  return (
    <>
    <div className="head-cis">
        <div className="title-cis">
          <Search
                    searchResults={searchResults}
                    setSearchResults={setSearchResults}
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                    onSearch={handleSearch}
                    dataObject={dataObject.data.techs}
                    setDataObject={setDataObject}
                    searchResult={searchResult}
                    setSearchResult={setSearchResult}
                    languaje={languaje}
                  />
          <div className={"cont-result-registers"+mode}>
          
                  <p style={{  textAlign: "center" }}>
                    &nbsp;
                    {capitalizeFirstLetter(lang[languaje]['resultadosEncontrados'])+" (" +
                      dataList.length +
                      ") " 
                      }
                  </p> 
          </div>
          <div className="cont-buttons-panel">
                  
                    {/* <Action
                    disabled={false}
                    origen="Azul"
                    titulo={"+ "+capitalizeFirstLetter(lang[languaje]['nuevaTecnologia'])}
                    action={crear}
                  /> */}
                  
                 
                </div>
        </div>
      </div>
      <div className="cont-cis">
      <div className="main-panel-portafolio">
        <div className="compact-content-portafolio">
        <div className={"content-portafolio-head"+mode}>
        {ServiceSelected.length === 0 ? '':
            <>
                <div
                  className="cont-btn-back-users"
                  style={{ width: "10%" }}
                  onClick={regresar_cis}
                >
                  <div className="cont-img-back-users">
                    <img
                      className="img-back-users"
                      src={(mode=='')?"/iconos/back.png":"/iconos/back-blanco.png"}
                      name="regresar"
                    />
                  </div>
                  <div className="cont-txt-back-users">
                    <div className={"txt-back-users"+mode}>{capitalizeFirstLetter(lang[languaje]['regresar'])}</div>
                  </div>
                </div>
                <div className={"txt-back-users"+mode+" sla-content"} style={{left:'0%'}}>{ServiceSelected.service_name }&nbsp;&nbsp;&nbsp;&nbsp;{ '     SLA: '+slaService+"%"}</div>
              </>
  }
       
                </div>
        <div className={"content-portafolio"+mode}>
          

          <div className="cont-portafolio-table">
            <div className="content-card-portafolio" id="content">
              { (
                <>
                  {/* {ServiceSelected.length === 0 ? ( */}
                    <TablePortafolioTech
                      pageActual={pageActual}
                       limitList={limitList} startLimit={startLimit}
                      dataList={dataList}
                      ServiceSelected={ServiceSelected}
                      setServiceSelected={setServiceSelected}
                      registerIsValid={registerIsValid}
                      searchResults={searchResults}
                      setSearchResults={setSearchResults}
                      searchTerm={searchTerm}
                      setSearchTerm={setSearchTerm}
                      dataUsers={dataUsers}
                      setDataUsers={setDataUsers}
                      server={server}
                      setRegisterIsValid={setRegisterIsValid}
                      setData={setData}
                      setLoading={setLoading}
                      setError={setError}
                      devices={devices}
                      setDataService={setDataService}
                      dataService={dataService}
                      handleChangEdit={handleChangEdit}
                      sla={slaService}
                      setSla={setSlaService}
                      languaje={languaje}
                      dataObject={dataObject}
                      setDataObject={setDataObject}
                      tecSelected={tecSelected}
                      setTecSelected={setTecSelected}
                      mode={mode}
                      handleShowPopup={handleShowPopup}
                    ></TablePortafolioTech>
                  {/* ) : ( */}
                    {/* <InfoPortafolio
                      server={server}
                      portfolioSelected={ServiceSelected}
                      searchResults={searchResults}
                      ServiceSelected={ServiceSelected}
                      setServiceSelected={setServiceSelected}
                      setSearchResults={setSearchResults}
                      searchTerm={searchTerm}
                      setSearchTerm={setSearchTerm}
                      onSearch={handleSearch}
                      dataUsers={dataUsers}
                      setDataUsers={setDataUsers}
                      registerIsValid={registerIsValid}
                      sla={sla}
                      setSla={setSla}
                      languaje={languaje}
                      dataObject={dataObject}
                      setDataObject={setDataObject}
                    ></InfoPortafolio> */}
                  {/* )} */}
                </>
              )}
            </div>
          </div>
        </div>
        <div className={"content-portafolio-footer"+mode}>
        <div className="cont-display-paginador">
<Paginador  pages={pages}
                    pageActual={pageActual}
                    setPageActual={setPageActual}
                    mode={mode}></Paginador>
        </div>
        <div className="cont-display-paginador">
              <div className={"cont-half-display-paginador"+mode}>
              
              <div>
                          <label htmlFor="selector">{capitalizeFirstLetter(lang[languaje]['filasPagina'])}: </label>
                          <select id="selector" value={limitList} className="pageSelector" onChange={handleSelectChange}>
                            <option value={10}>10</option>
                            <option value={50} >50</option>
                            <option value={100}>100</option>
                            <option value={500}>500</option>
                            <option value={1000}>1000</option>
                          </select>
                      </div>
              </div>
              <div className={"cont-half-display-paginador"+mode}>
              <p style={{  textAlign: "center" }}>
                    &nbsp;
                    {"(" +
                      (startLimit + 1) +
                      " - " +
                      (dataList.length >  parseInt(pageActual ) * parseInt(limitList)
                        ?  parseInt(pageActual ) * parseInt(limitList)
                        : dataList.length) +
                      ")  "+lang[languaje]['de']+" " +
                      dataList.length +
                      " "+lang[languaje]['resultados']}
                  </p>
              </div>
        </div>
        
        </div>
        </div>
      </div>
      </div>
      <Modal
    isOpen={CreateServiceModalOpen}
    // isOpen={false}
    // onAfterOpen={afterOpenExeption}
    onRequestClose={closCreateServiceModal}
    style={CreateCisModalStyles}
    contentLabel="Example Modal2"
    shouldCloseOnOverlayClick={false}
    >
        <ModalCreateTech
      // devices={devices}
      languaje={languaje}
      mode={mode}
      tecSelected={tecSelected}
      ServiceSelected={ServiceSelected}
      dataCisConf={dataUsers}
      server={server}
      dataUsers={dataUsers}
      editActive={editActive}
      setEditActive={setEditActive}
      setDataService={setDataService}
      dataTech={dataService}
      setData={setData}
      loading={loading}
      setLoading={setLoading}
      setError={setError}
      setRegisterIsValid={setRegisterIsValid}
      closCreateTechModal={closCreateServiceModal}
    ></ModalCreateTech>
    </Modal>
    </>
  );
};

export default PanelPortafolioTecs;
